import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import * as optionHeaderStyles from './OptionHeader.styles';

export interface OptionHeaderProps {
  title: string;
  subTitle?: string;
}

function OptionHeader({ title, subTitle }: OptionHeaderProps) {
  const { classes: typographyClasses } = optionHeaderStyles.useTypographyStyles();

  return (
    <Box mb={1.5}>
      <Typography component="h3" className={typographyClasses.root}>
        {title}
      </Typography>
      {subTitle && (
        <Typography component="h5" className={typographyClasses.sub}>
          {subTitle}
        </Typography>
      )}
    </Box>
  );
}

export default OptionHeader;
